import { VirtualType } from '../types';

import { createProxy, dispatchError } from './utils';

export async function makeModuleVirtualModule(
  { name, virtual }: { name: string; virtual?: VirtualType },
  url: string,
  fn: () => void,
): Promise<void> {
  const res = await fetch(url);
  const script = await res.text();

  try {
    new Function(`
      if(arguments[0].virtual.dom) {
        var document = new Document().implementation.createHTMLDocument('module ${name} DOM');
      } else {
        var document = arguments[0].window.document;
      }

      if(arguments[0].virtual.window) {
        var window = arguments[0].createProxy();

        window.showcase_connected = arguments[0].window.showcase_connected;
        window.showcase_modules = arguments[0].window.showcase_modules;
        window.document = document;
        window.trustedTypes = arguments[0].window.trustedTypes;
        
        var d = Object.defineProperty(document, 'defaultView', {
          value: window,
          writable: true,
        });

        window.document = d;
        var globalThis = window;
      } else {
        window.document = document;
      }
      ${script}
      return document;
  `)({ window, virtual, createProxy });
    fn();
  } catch (e) {
    dispatchError(name, (e as any).message);
  }
}
